import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import SearchBar from '../components/molecules/SearchBar';
import ComponentCard from '../components/organisms/ComponentCard';
import { getAllComponents, getComponentsByCategory } from '../api/componentService';
import { CATEGORIES } from '../utils/constants';

const Categories = () => {
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const [category, setCategory] = useState(params.get('c') || 'All');
  const [components, setComponents] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const c = params.get('c') || 'All';
    setCategory(c);
    load(c);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const load = async (cat) => {
    setLoading(true);
    try {
      if (cat && cat !== 'All') {
        const res = await getComponentsByCategory(cat);
        setComponents(res.data);
      } else {
        const res = await getAllComponents();
        setComponents(res.data);
      }
    } finally {
      setLoading(false);
    }
  };

  const filtered = components.filter((c) =>
    c.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    c.description?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const onView = (id) => navigate(`/components/view/${id}`);

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6 flex flex-col sm:flex-row gap-4 justify-between items-start sm:items-center">
          <h1 className="text-3xl font-bold text-gray-900">Browse by Category</h1>
          <div className="w-full sm:max-w-sm">
            <SearchBar value={searchQuery} onChange={setSearchQuery} placeholder="Search in category..." />
          </div>
        </div>

        <div className="flex gap-2 flex-wrap mb-8">
          <button
            className={`px-3 py-1.5 rounded-full text-sm border ${category==='All'?'bg-purple-600 text-white border-purple-600':'border-gray-200 text-gray-700 hover:bg-gray-100'}`}
            onClick={() => setParams({})}
          >
            All
          </button>
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              className={`px-3 py-1.5 rounded-full text-sm border ${category===cat?'bg-purple-600 text-white border-purple-600':'border-gray-200 text-gray-700 hover:bg-gray-100'}`}
              onClick={() => setParams({ c: cat })}
            >
              {cat}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500 mx-auto" />
          </div>
        ) : filtered.length ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((component) => (
              <ComponentCard
                key={component.id}
                component={{
                  ...component,
                  type: component.category || 'UI Element',
                  tags: component.tags || [],
                  updatedAt: component.updatedAt || Date.now(),
                }}
                isPrivate={component.visibility === 'private'}
                onView={onView}
              />
            ))}
          </div>
        ) : (
          <div className="text-center text-gray-500 py-12">No components found.</div>
        )}
      </main>
    </div>
  );
};

export default Categories;
